import React from "react";
import styles from "./TargetMark.module.scss";
import {isBetween} from "@/helpers/isBetween.js";

export default function TargetMark({ranges, score, targetRange}) {
  const targetStart = Math.min(...targetRange.map(o => o.y));
  let targetStartP = Math.min(...targetRange.map(o => o.percentage));
  const targetEnd = Math.max(...targetRange.map(o => o.y));
  const targetEndP = Math.max(...targetRange.map(o => o.percentage));
  const isTargetHit = isBetween(score, targetStart, targetEnd);

  const targetBarWidthPercentage = targetEndP - targetStartP;

  if (targetStart == 0 && targetEnd == 0) {
    return null;
  }
  const hasHigherRange = ranges.some(range => range.x === "border-high" || range.x === "high");
  if (!hasHigherRange && targetEndP > 100) {
    targetStartP = targetStartP - targetBarWidthPercentage;
  }

  return (
    <div
      className={styles.target}
      data-active={isTargetHit}
      style={{
        left: `${targetStartP}%`,
        width: `${targetBarWidthPercentage}%`,
      }}>
      <div className={styles.targetMark}>
        <div className={styles.bullseye}></div>
      </div>
    </div>
  );
}
